import * as React from 'react';
import { useServiceResolver } from '@services/useServiceResolver';
import { useAppContext } from '@contexts/app/hooks/useAppContext';
import { useMemberContext } from '@contexts/member/hooks/useMemberContext';
import { WebAnalyticsBinder } from '@services/analytics/types';
import { useSDKSettings } from '@contexts/sdkSettings/hooks/useSDKSettings';

export const useWebAnalyticBinder = (binder: WebAnalyticsBinder) => {
    const { webAnalyticsService } = useServiceResolver();
    const appContext = useAppContext();
    const { member } = useMemberContext();
    const { analyticsSessionId } = useSDKSettings();

    React.useEffect(() => {
        webAnalyticsService.bind(binder, appContext, member, analyticsSessionId);
    }, [appContext, member]);
};
